/*
 * Author M. Atoar Rahman
 * Title: Current Stock
 * Description: Page for Current Stock
 * Date: 13/07/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { CurrentStockProvider } from '../misReports/currentStock/ContextAPI';
import Index from '../misReports/currentStock/Index';
import PermissionDenied from './PermissionDenied';

export default function CurrentStock() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['current-stock']) return <PermissionDenied />;

    return (
        <CurrentStockProvider>
            <Index />
        </CurrentStockProvider>
    );
}
